module.exports = __webpack_public_path__ + "ninja-apple-touch-icon.png";